<template>
  <div class="form-container">
    <div class="form-header">
      <div class="title">{{ $t("form_title") }}</div>
      <div class="desc">{{ $t("form_description") }}</div>
    </div>
    <div class="form-body">
      <div class="form-section section-general">
        <div class="sub-title">{{ $t("general") }}</div>
        <div class="name-section input-section">
          <div class="input-title">
            {{ $t("certificate_template_name_title")
            }}<span class="mandatory">*</span>:
          </div>
          <cert-input-text
            :place-holder-text="$t('certificate_template_name_placeholder')"
            :max-length="50"
            v-model="seriesData.certificate_template.template_name"
          />
        </div>
        <div class="color-section input-section">
          <div class="input-title">{{ $t("certificate_color_title") }}</div>
          <ul class="list-inline">
            <li v-for="(item, i) in templateColors" :key="i">
              <cert-radio-button
                :radio-name="'color'"
                :radio-value="item"
                :radio-color="item"
                :radio-checked="seriesData.certificate_template.color === item"
                :radio-text="$t(item)"
                v-model="seriesData.certificate_template.color"
              />
            </li>
          </ul>
        </div>
        <div class="logo-1-section input-section">
          <div class="input-title">
            {{ $t("logo_title", ["1"]) }}<span class="mandatory">*</span>:
          </div>
          <!-- button with click event to open uploader -->
          <cert-uploader-button
            @buttonclick="openModalUploader"
            :upload-type="'logo'"
            v-model="this.seriesData.certificate_template.logo"
          ></cert-uploader-button>

          <div class="input-rec">{{ $t("logo_1_size") }}</div>
        </div>
        <div class="logo-2-section">
          <cert-button-add-section
            :button-text="$t('button_add_logo')"
            v-if="!formData.showLogo2"
            @click="toggleLogo2"
          />
          <div class="logo-2-section-add" v-else>
            <div class="logo-2-controls f-clear">
              <div class="input-title f-left">{{ $t("logo2_title") }}</div>
              <div class="remove-section f-right">
                <a href="#" @click.prevent="toggleLogo2">{{ $t("remove") }}</a>
              </div>
            </div>
            <cert-uploader-button
              @buttonclick="openModalUploader"
              :upload-type="'logo_opt'"
              v-model="this.seriesData.certificate_template.logo_opt"
            ></cert-uploader-button>
            <div class="input-rec">{{ $t("logo_2_size") }}</div>
          </div>
        </div>
      </div>
      <hr />
      <div class="form-section section-translation">
        <div class="title-section">
          <div class="input-title">
            {{ $t("certificate_title") }}<span class="mandatory">*</span>:
          </div>
          <cert-input-text
            :place-holder-text="$t('certificate_title_placeholder')"
            :max-length="100"
            :input-show-button="true"
            :input-button-text="seriesData.default_lang"
            :input-button-click-param="'title'"
            v-model="
              seriesData.certificate_template.resources[seriesData.default_lang]
                .title
            "
            @buttonclick="openModal"
          />
        </div>
        <div class="description-section input-section">
          <div class="input-title">
            {{ $t("certificate_description") }}<span class="mandatory">*</span>:
          </div>
          <div
            class="description-tags-link"
            v-if="formData.product == 'mtm' && formData.tagsLink.length > 0"
          >
            {{ $t("form_display_class_details") }}
            <a :href="formData.tagsLink" target="_blank">{{
              $t("form_by_adding_tags")
            }}</a>
          </div>
          <cert-input-text
            :place-holder-text="$t('certificate_description_placeholder')"
            :max-length="580"
            :input-show-button="true"
            :input-button-text="seriesData.default_lang"
            :input-button-click-param="'description'"
            v-model="
              seriesData.certificate_template.resources[seriesData.default_lang]
                .description
            "
            @buttonclick="openModal"
          />
        </div>
        <div class="signature-1-section input-section">
          <div class="input-title">
            {{ $t("certificate_signature_section", ["1"])
            }}<span class="mandatory">*</span>:
          </div>
          <cert-input-text
            :place-holder-text="$t('certificate_signature_name_placeholder')"
            :max-length="50"
            v-model="seriesData.certificate_template.signature_name"
          />
          <cert-input-text
            :place-holder-text="$t('certificate_signature_title_placeholder')"
            :max-length="100"
            :input-show-button="true"
            :input-button-text="seriesData.default_lang"
            :input-button-click-param="'signature_title'"
            v-model="
              seriesData.certificate_template.resources[seriesData.default_lang]
                .signature_title
            "
            @buttonclick="openModal"
            class="signature-spacing"
          />
          <cert-uploader-button
            @buttonclick="openModalUploader"
            :upload-type="'signature_logo'"
            class="signature-spacing"
            v-model="this.seriesData.certificate_template.signature_logo"
          ></cert-uploader-button>
        </div>
        <div class="signature-2-section input-section">
          <cert-button-add-section
            :button-text="$t('button_add_signature')"
            v-if="!formData.showSignature2"
            @click="toggleSig2"
          />
          <div class="signature-2-add" v-else>
            <div class="signature-2-controls f-clear">
              <div class="input-title f-left">
                {{ $t("certificate_signature_section", ["2"]) }}:
              </div>
              <div class="remove-section f-right">
                <a href="#" @click.prevent="toggleSig2">{{ $t("remove") }}</a>
              </div>
            </div>
            <cert-input-text
              :place-holder-text="$t('certificate_signature_name_placeholder')"
              :max-length="50"
              v-model="seriesData.certificate_template.signature_name_opt"
            />
            <cert-input-text
              :place-holder-text="$t('certificate_signature_title_placeholder')"
              :max-length="100"
              v-model="
                seriesData.certificate_template.resources[
                  seriesData.default_lang
                ].signature_title_opt
              "
              :input-show-button="true"
              :input-button-text="seriesData.default_lang"
              :input-button-click-param="'signature_title_opt'"
              @buttonclick="openModal"
              class="signature-spacing"
            />
            <cert-uploader-button
              @buttonclick="openModalUploader"
              :upload-type="'signature_logo_opt'"
              class="signature-spacing"
              v-model="this.seriesData.certificate_template.signature_logo_opt"
            ></cert-uploader-button>
          </div>
        </div>
      </div>
      <div class="form-section">
        <div class="form-controls f-clear">
          <cert-cancel-button
            class="f-left"
            :button-text="$t('cancel')"
            @click="cancelForm"
          />
          <cert-confirm-button
            class="f-right"
            :button-text="$t('save')"
            :button-disabled="!isFormValid"
            @click="saveForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CertUploaderButton from "./form/CertUploaderButton";
import CertInputText from "./form/CertInputText";
import CertButtonAddSection from "./form/CertButtonAddSection";
import CertRadioButton from "./form/CertRadioButton";
import CertCancelButton from "./form/CertCancelButton";
import CertConfirmButton from "./form/CertConfirmButton";
import { insertSeries, updateSeries } from "../utilities/api";
import { createNewGUID } from "../utilities/general";
export default {
  name: "CertForm",
  props: {
    currentCulture: Object,
    formData: Object,
    seriesData: Object,
    modalOptions: Object,
    uploadOptions: Object,
  },
  data() {
    return {
      templateColors: ["blue", "red", "green", "brown"],
      showUploader: false,
    };
  },
  components: {
    CertInputText,
    CertButtonAddSection,
    CertRadioButton,
    CertCancelButton,
    CertConfirmButton,
    CertUploaderButton,
  },
  computed: {
    isFormValid() {
      const defaultLang = this.seriesData.default_lang;
      return (
        this.seriesData.certificate_template.logo.length > 0 &&
        this.seriesData.certificate_template.signature_logo.length > 0 &&
        this.seriesData.certificate_template.signature_name.length > 0 &&
        this.seriesData.certificate_template.template_name.length > 0 &&
        this.seriesData.certificate_template.resources[defaultLang].title
          .length > 0 &&
        this.seriesData.certificate_template.resources[defaultLang].description
          .length > 0 &&
        this.seriesData.certificate_template.resources[defaultLang]
          .signature_title.length > 0 &&
        ((this.seriesData.certificate_template.signature_logo_opt.length ===
          0 &&
          this.seriesData.certificate_template.resources[defaultLang]
            .signature_title_opt.length === 0 &&
          this.seriesData.certificate_template.signature_name_opt.length ===
            0) ||
          (this.seriesData.certificate_template.signature_logo_opt.length > 0 &&
            this.seriesData.certificate_template.resources[defaultLang]
              .signature_title_opt.length > 0 &&
            this.seriesData.certificate_template.signature_name_opt.length > 0))
      );
    },
  },
  methods: {
    logo1Changed: function (base64) {
      this.seriesData.certificate_template.logo_id = createNewGUID();
      this.seriesData.certificate_template.logo = base64;
    },
    logo2Changed: function (base64) {
      this.seriesData.certificate_template.logo_opt_id = createNewGUID();
      this.seriesData.certificate_template.logo_opt = base64;
    },
    signature1ImageChanged: function (base64) {
      this.seriesData.certificate_template.signature_logo_id = createNewGUID();
      this.seriesData.certificate_template.signature_logo = base64;
    },
    signature2ImageChanged: function (base64) {
      this.seriesData.certificate_template.signature_logo_opt_id =
        createNewGUID();
      this.seriesData.certificate_template.signature_logo_opt = base64;
    },
    openModalUploader(param) {
      this.uploadOptions.editedValue = param.param;
      this.uploadOptions.focusBackElem = param.e.target;
      this.uploadOptions.active = true;
    },
    toggleLogo2() {
      this.formData.showLogo2 = !this.formData.showLogo2;
      if (!this.formData.showLogo2) {
        this.seriesData.certificate_template.logo_opt = "";
      }
    },
    toggleSig2() {
      this.formData.showSignature2 = !this.formData.showSignature2;
      if (!this.formData.showSignature2) {
        this.seriesData.certificate_template.signature_logo_opt = "";
        Object.entries(this.seriesData.certificate_template.resources).forEach(
          (x) => {
            x[1].signature_title_opt = "";
          }
        );
        this.seriesData.certificate_template.signature_name_opt = "";
      }
    },
    fileError(error) {
      alert("Error: " + error);
    },
    openModal(param) {
      this.modalOptions.editedValue = param.param;
      this.modalOptions.focusBackElem = param.e.target;
      this.modalOptions.inputLength = param.length;
      this.modalOptions.active = true;
    },
    messageParent(message) {
      if (this.formData.inIframe) {
        parent.postMessage(message, "*");
      }
    },
    cancelForm() {
      this.messageParent({ success: true, action: "formCancel" });
    },
    saveForm() {
      if (this.formData.create) {
        insertSeries(
          this.formData.token,
          this.formData.seriesID,
          this.seriesData
        ).then((data) => {
          if (!data.onError) {
            this.manageSuccess(data.response);
          } else {
            this.manageError(data.response);
          }
        });
      } else {
        updateSeries(
          this.formData.token,
          this.formData.seriesID,
          this.seriesData
        ).then((data) => {
          if (!data.onError) {
            this.manageSuccess(data.response);
          } else {
            this.manageError(data.response);
          }
        });
      }
    },
    extractDescription() {
      let data = { resources: {} };
      const keys = Object.keys(this.seriesData.certificate_template.resources);
      for (let i = 0; i < keys.length; ++i) {
        data.resources[keys[i]] = {
          description:
            this.seriesData.certificate_template.resources[keys[i]].description,
        };
      }

      return data;
    },
    manageSuccess() {
      const newSeries = { ...this.seriesData, ...this.extractDescription() };
      this.messageParent({
        success: true,
        action: "formSave",
        series_data: newSeries,
      });
    },
    manageError() {
      this.messageParent({ success: false, action: "formSave" });
    },
  },
};
</script>

<style lang="scss" scoped>
.mtm {
  .form-body .remove-section {
    a:hover,
    a:focus {
      color: $exMtm;
    }
  }
}
.input-section {
  margin-top: 25px;
}

span.mandatory {
  color: $t1Red;
}

ul {
  font-size: 0;
}

.form-container {
  width: 345px;
  box-shadow: $dropShadow;
  min-height: 100%;
  background-color: #fff;
  flex-shrink: 0;
}

.form-header {
  padding: 30px;
  box-shadow: $dropShadow;

  .culture-container {
    padding: 15px 0 0 0;
  }
}

.title {
  color: $darkBlue;
  @include fontSize(24px);
  font-weight: bold;
  line-height: 19px;
}

.sub-title {
  color: $darkBlue;
  @include fontSize(16px);
  font-weight: bold;
  line-height: 19px;
}

.desc {
  color: $lightGray;
  @include fontSize(14px);
  line-height: 17px;
  margin-top: 8px;
}
.description-tags-link {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.8px;
  margin: 8px 0;
}

.form-body {
  .form-section {
    padding: 30px;
  }

  .input-title {
    color: $formDarkBlue;
    @include fontSize(14px);
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
    margin: 5px 0;
  }

  .input-rec {
    color: $formLightGray;
    @include fontSize(12px);
    letter-spacing: 0;
    line-height: 15px;
    padding: 5px 0 0 0;
  }

  .remove-section {
    a {
      color: $formDarkBlue;
      @include fontSize(14px);
      font-weight: bold;
      letter-spacing: 0;
      line-height: 17px;
    }

    a:hover,
    a:focus {
      color: $exBlue;
    }
  }

  .logo-2-section {
    padding: 25px 0;
  }

  .signature-spacing {
    margin-top: 8px;
  }

  > hr {
    border: 1px solid $borderLightGray;
  }
}
</style>
